import React, { useState, useEffect } from 'react';
import { Col, Row, Container } from 'reactstrap';
import { Link } from 'react-router-dom';
import MapboxMap from './MapboxMap';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from '../ExtraPages/firebaseConfig';

const Cta = () => {
  //Signup Modal
  const [modal2, setModal2] = useState(false);
  const [userRole, setUserRole] = useState(null);
  const [loading, setLoading] = useState(true);

  const openModal2 = () => setModal2(!modal2);

  useEffect(() => {
    const fetchUserRole = async (uid) => {
      try {
        const response = await fetch(
          `https://api.starmarketapi.online/login_firebase/user-role/${uid}`
        );
        if (!response.ok) {
          throw new Error('Failed to fetch user role');
        }
        const data = await response.json();
        setUserRole(data.role);
      } catch (error) {
        console.error('Error fetching user role:', error);
        setUserRole(null);
      } finally {
        setLoading(false);
      }
    };

    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        fetchUserRole(user.uid);
      } else {
        setUserRole(null);
        setLoading(false);
      }
    });

    return () => unsubscribe();
  }, []);

  // Only show map for buyers
  if (loading) {
    return null; // Or return a loading spinner if needed
  }

  if (userRole !== 'buyer') {
    return null; // Don't render anything if not a buyer
  }

  return (
    <React.Fragment>
      <section className="bg-light gaps">
        <Container
          fluid
          style={{ padding: 0 }}
        >
          <div
            className="section-title mb-4"
            style={{ paddingLeft: '15px', paddingRight: '15px' }}
          >
            <span
              className="subtitle"
              style={{ fontWeight: '600' }}
            >
              Shop By Locations
            </span>

            <p className="text-muted mb-1"></p>
          </div>

          <MapboxMap
            onMarkerClick={openModal2}
            style={{ borderRadius: '20px', width: '100%' }}
          />
        </Container>
      </section>
    </React.Fragment>
  );
};

export default Cta;
